import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-associated-panel',
  templateUrl: './associated-panel.component.html',
  styleUrls: ['./associated-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AssociatedPanelComponent implements OnInit {
  @Input() panelTitle!: string;
  @Input() externalLinkSectionTitle!: string;
  @Input() externalLinkUrl!: string;

  constructor() {}

  ngOnInit(): void {}
}
